import * as API from "../../api";
import * as ActionTypes from "../action-types";

import { message } from 'antd'

// Redux Action
import {  
    setLoadingFuelAnalysisDashboard, 
    unsetLoadingFuelAnalysisDashboard 
} from './style'

export const get_vehicle_report_daily_summary_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleReportDailySummaryTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                reportVehicleDailySummary,
                msg,
                status
            } = info

            if(status === 200) {
                reportVehicleDailySummary && dispatch(get_vehicle_report_daily_summary_by_timeframe_success(vid, reportVehicleDailySummary, {}, startTime, endTime))
                
                if(!reportVehicleDailySummary?.length) {
                    message.error('No data available!')
                }
            } else {
                message.error(msg)
            }



        } catch(err) {
            // message.error('Error in getting timeframe vehicle daily summary report. Refresh page?')
        }
    })
    
}

export const get_vehicle_report_summary_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleReportSummaryTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                daily,
                summary,
                msg,
                status
            } = info

            if(status === 200) {
                daily && dispatch(get_vehicle_report_summary_by_timeframe_success(vid, daily, summary, startTime, endTime))
            } else {
                message.error(msg)
            }


        } catch(err) {
            console.error('ERROR:', err) 
            // message.error('Error in getting vehicle summary report. Refresh page?')
        }
    })
    
}

const get_vehicle_report_summary_by_timeframe_success = (vid, reportVehicleDailySummary, summary, startTime, endTime) => {
    return {
        type: ActionTypes.GET_VEHICLE_DAILY_SUMMARY_REPORTS,
        vid,
        reportVehicleDailySummary,
        summary,
        startTime, 
        endTime
    }
}

const get_vehicle_report_daily_summary_by_timeframe_success = (vid, reportVehicleDailySummary, summary, startTime, endTime) => {
    return {
        type: ActionTypes.GET_VEHICLE_DAILY_SUMMARY_REPORTS,
        vid,
        reportVehicleDailySummary,
        summary,
        startTime, 
        endTime
    }
}

export const clear_vehicle_daily_summary_reports_success = () => {
    return {
        type: ActionTypes.CLEAR_VEHICLE_DAILY_SUMMARY_REPORTS
    }
}

export const get_vehicle_geofence_by_timeframe_request = (vids, startTime, endTime) => dispatch => {
    
    return API
    .getVehicleGeofenceReportTimeFrameSync(vids, startTime, endTime)
    .then(info => {
        
        try {
            const {
                geofenceRecords,
                geofences,
                status,
                msg
            } = info

            if(status === 200) {
                geofenceRecords && dispatch(get_vehicle_geofence_by_timeframe_success(vids, geofenceRecords, geofences))
            } else {
                message.error(msg)
            }


        } catch(err) {
            message.error('Error in getting timeframe vehicle geofence report. Refresh page?')
        }
    })

}

const get_vehicle_geofence_by_timeframe_success = (vid, geofenceRecords, geofences) => {

    return {
        type: ActionTypes.GET_VEHICLE_GEOFENCE_REPORTS,
        vid,
        geofenceRecords,
        geofences
    }
}

export const get_vehicle_refuel_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    return API
    .getVehicleRefuelReportTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                report,
                msg,
                status
            } = info

            if(status === 200) {
                report && dispatch(get_vehicle_refuel_by_timeframe_success(vid, report))
            } else {
                message.error(msg)
            }


        } catch(err) {
            message.error('Error in getting timeframe vehicle refuel report. Refresh page?')
        }
    })

}

const get_vehicle_refuel_by_timeframe_success = (vid, report) => {
    return {
        type: ActionTypes.GET_VEHICLE_REFUEL_REPORTS,
        vid,
        report
    }
}

export const get_vehicle_report_fuel_analysis_by_timeframe_request = (vid, startTime, endTime) => dispatch => {

    dispatch(setLoadingFuelAnalysisDashboard())

    return API
    .getVehicleReportFuelAnalysisTimeFrameSync(vid, startTime, endTime)
    .then(info => {
        
        try {
            const {
                report,
                status,
                msg
            } = info

            report && dispatch(get_vehicle_report_fuel_analysis_by_timeframe_success(vid, report))

            if(status !== 200) {
                dispatch(clear_vehicle_report_fuel_analysis_by_timeframe_success())
                message.error(msg || 'Error in getting fuel analysis report.')
            }

        } catch(err) {
            message.error('Error in getting fuel analysis summary report. Refresh page?')
        }
    })
    .finally(() => {
        dispatch(unsetLoadingFuelAnalysisDashboard())
    })
    
}

const get_vehicle_report_fuel_analysis_by_timeframe_success = (vid, report) => {
    return {
        type: ActionTypes.GET_VEHICLE_FUEL_ANALYSIS_REPORTS,
        vid,
        report
    }
}
export const clear_vehicle_report_fuel_analysis_by_timeframe_success = () => {
    return {
        type: ActionTypes.CLEAR_VEHICLE_FUEL_ANALYSIS_REPORTS,
    }
}

export const get_vehicle_utilisation_report_by_timeframe_request = (vid, startTime, endTime, uid) => dispatch => {

    return API
    .getVehicleUtilisationReportTimeFrameSync(vid, startTime, endTime, uid)
    .then(info => {
        
        try {
            const {
                reportVehicleDailySummary,
                msg,
                status
            } = info

            if(status === 200) {
                reportVehicleDailySummary && dispatch(get_vehicle_utilisation_report_by_timeframe_success(vid, reportVehicleDailySummary))
    
                if(!reportVehicleDailySummary) {
                    message.error('No Data available!')
                }
            } else {
                message.error(msg)
            }

        } catch(err) {
            message.error('Error in getting vehicle utilisation report. Retry?')
        }
    })
    
}

const get_vehicle_utilisation_report_by_timeframe_success = (vid, report) => {
    return {
        type: ActionTypes.GET_VEHICLE_UTILISATION_REPORTS,
        vid,
        report
    }
}

export const clear_vehicle_utilisation_report_request = () => dispatch => {
    dispatch(clear_vehicle_utilisation_report_success())
}

const clear_vehicle_utilisation_report_success = () => {
    return {
        type: ActionTypes.CLEAR_VEHICLE_UTILISATION_REPORTS
    }
}